/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import IconComponent from '../../Icon';

import MobileFlyoutDropdownMenu from '../MobileFlyoutDropdownMenu';

import { MobileFlyoutMegaMenuItemProps } from './_props';

import useMobileFlyoutMegaMenuTheme from './themes';

/**
 * MobileFlyoutMegaMenuItem Component
 */

function MobileFlyoutMegaMenuItem({
  subMenuSubItem,
  mobileFlyoutActiveItem,
  toggleMobileFlyoutActiveItem,
}: MobileFlyoutMegaMenuItemProps) {
  const { megaMenuItemClasses, megaMenuItemNameClasses, megaMenuIconProps, ExpandMoreIcon, ExpandLessIcon } =
    useMobileFlyoutMegaMenuTheme();

  return (
    <li key={subMenuSubItem.id} className={megaMenuItemClasses}>
      <button
        type="button"
        className={megaMenuItemNameClasses}
        onClick={() => toggleMobileFlyoutActiveItem(subMenuSubItem.id)}
      >
        {subMenuSubItem.label}

        {subMenuSubItem.children.length > 0 && (
          <IconComponent
            Icon={mobileFlyoutActiveItem === subMenuSubItem.id ? ExpandLessIcon : ExpandMoreIcon}
            {...megaMenuIconProps}
          />
        )}
      </button>

      <MobileFlyoutDropdownMenu
        mobileMenuActiveItem={mobileFlyoutActiveItem}
        subMenuItem={subMenuSubItem}
        hasIcon={false}
      />
    </li>
  );
}

/**
 * Exports
 */

export default MobileFlyoutMegaMenuItem;
